module.exports = "<div class=\"card\">\r\n    Hello World!\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/bot-summary/bot-summary.component.html
// module id = ../../../../../src/app/components/bot-summary/bot-summary.component.html
// module chunks = main